import { development_category, services_category } from '../utils/DictionaryManagementUtils';
import { DEVELOPMENT_MODE } from '../utils/ExternalKeys';

export const arrangeScreenInJson = (json, onConfigChanged) => {
  json.screens = arrangeScreen(json.screensList, json.configurations);
  if (onConfigChanged) {
    onConfigChanged();
  }
};

const arrangeScreen = (screens, configurations) => configurations.screens_ordering
  .map((screenCategory) => {
    const screensByCategory = screens.filter((screen) => screen.category === screenCategory);
    if (screenCategory === services_category) {
      return sortServices(screensByCategory, configurations.services);
    }
    if (screenCategory === development_category && !DEVELOPMENT_MODE) {
      return [];
    }
    return screensByCategory;
  })
  .reduce(reducer, []);

const sortServices = (screens, configurations) => configurations.screens_ordering
  .map((serviceKey) => {
    const service = configurations[serviceKey];
    return (sortFlow(screens.filter((screen) => service.selected && screen.sub_category === service.sub_category
            && screen.duplication_number === service.duplication_number), configurations[serviceKey]));
  })
  .reduce(reducer, screens.filter((screen) => screen.sub_category === 'menu'));

const sortFlow = (screens, configurations) => configurations.screens_ordering
  .map((stepName) => {
    const screensBySteps = screens.filter((screen) => screen.step === stepName);
    switch (stepName) {
      case 'recipient':
        return sortRecipient(screensBySteps, configurations[stepName]);
      case 'amount_package':
      case 'amount':
      case 'select_bill':
        return sortAmount(screensBySteps, configurations[stepName]);
      default:
        return screensBySteps;
    }
  })
  .reduce(reducer, []);

const sortRecipient = (screens, configurations) => configurations.screens_ordering
  .map((recipient_name) => screens.filter((screen) => filterRecipient(recipient_name, screen, configurations)))
  .reduce(reducer, screens.filter((screen) => filterInitialRecipient(screen, configurations)));

const sortAmount = (screens, configurations) => screens
  .filter((screen) => ((screen.amount_step === 'change_paying_account' ? configurations.show_account_balance
    : screen.screen_name !== 'pay_bills_choose_method' && screen.screen_name !== 'pay_bills_enter_code' && true)
      || ((screen.screen_name === 'pay_bills_choose_method' && configurations.enable_customer_to_bill_code_manually)
          || (screen.screen_name === 'pay_bills_enter_code' && configurations.enable_customer_to_bill_code_manually))
  ));

const filterInitialRecipient = (screen, configurations) => screen.recipient_step === 'menu'
    || (configurations.customer_should_select_recipient_request && configurations.select_from_recipients_list
        && screen.recipient_step === 'search_results')
    || (configurations.customer_should_select_recipient_request && configurations.add_recipient_manually && screen.recipient_step === 'transfer_method');

const filterRecipient = (recipient_name, screen, configurations) => configurations.customer_should_select_recipient_request
    && configurations.add_recipient_manually
    && screen.recipient_step === recipient_name
    && configurations.manual_recipients[recipient_name].selected;

export const arrangeScreenForSlideshow = (json) => {
  json.screens = arrangeScreenSlideshow(json.screensList, json.configurations);
};

const arrangeScreenSlideshow = (screens, configurations) => configurations.screens_ordering_slideshow
  .map((screenCategory) => {
    const screensCategory = screens.filter((screen) => screen.category === screenCategory);
    return (screenCategory === services_category
      ? sortServices(screensCategory, configurations.services)
      : screensCategory);
  }).reduce(reducer, []);

const reducer = (previousValue, currentValue) => previousValue.concat(currentValue);
